import { UseChatHelpers } from '@ai-sdk/react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SvbrgAgentId } from '@/generated/gql/graphql';
import { Metadata, UIChatMessage } from '@/legacy/components/Chat/chat.types';
import { getConversationMessageSubmit } from '@/legacy/components/ConversationContextProvider/ConversationContextProvider.hook';
import { I18nNamespace } from '~/common/types';
import { SubmitArgs } from '~/components/Chat/ChatUserMessage/ChatUserMessage.types';

export function useAgentSubmitHandler(
  agentId?: SvbrgAgentId,
  sendMessage?: UseChatHelpers<UIChatMessage>['sendMessage'],
) {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'Chat.agents' });

  const agentContextMap = useMemo<{ [key in SvbrgAgentId]?: string }>(
    () => ({
      quoteComparisonAgent: t('quoteComparisonAgent.defaultMessage'),
      contractComparisonAgent: t('contractComparisonAgent.defaultMessage'),
      policyCheckerAgent: t('policyCheckerAgent.defaultMessage'),
      sourcerAgent: t('sourcerAgent.defaultUploadMessage'),
    }),
    [t],
  );

  const defaultText = (agentId ? agentContextMap[agentId] : undefined) || '';

  return async (args: SubmitArgs, metadata?: Metadata) => {
    if (!sendMessage) return;
    const submitHandler = getConversationMessageSubmit({ sendMessage });
    const input: SubmitArgs = args.text ? args : { text: defaultText };
    submitHandler(input, metadata);
  };
}
